import React from 'react';
import { motion } from 'framer-motion';
import { Target, Filter, Handshake } from 'lucide-react';
const steps = [{
  number: '01',
  icon: Target,
  title: 'Estrategia',
  description: 'Definimos el precio correcto para no perder plata ni tiempo'
}, {
  number: '02',
  icon: Filter,
  title: 'Exposición + filtro',
  description: 'Recibimos todos los contactos y eliminamos curiosos y corredores'
}, {
  number: '03',
  icon: Handshake,
  title: 'Cierre',
  description: 'Te guiamos para negociar mejor y cerrar sin errores'
}];
export function HowItWorks() {
  return <section className="py-24 px-6 bg-white" data-id="element-91">
      <div className="max-w-5xl mx-auto" data-id="element-92">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-93">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-gray-900" data-id="element-94">
            Un sistema simple en 3 etapas
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-95">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-px bg-gray-100 -z-10" data-id="element-96" />

          {steps.map((step, index) => {
          const Icon = step.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="relative flex flex-col items-center text-center group" data-id="element-97">
                <div className="w-24 h-24 rounded-full bg-white border-8 border-white shadow-sm flex items-center justify-center relative z-10 mb-6 group-hover:scale-105 transition-transform duration-300" data-id="element-98">
                  <div className="absolute inset-0 rounded-full bg-brand-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-99" />
                  <Icon size={32} className="text-brand-600 relative z-10" data-id="element-100" />
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-gray-900 text-white text-sm font-bold rounded-full flex items-center justify-center border-2 border-white" data-id="element-101">
                    {step.number}
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-102">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-103">
                  {step.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}